import { styled } from '@linaria/react';
import { bodyFont, colors, fonts, layout, semantic, shadow, space } from '../../theme/tokens';

export const Container = styled.div<{ $open: boolean; $aboveMobileNav?: boolean }>`
  position: fixed;
  inset: 0;
  z-index: ${({ $aboveMobileNav }) => ($aboveMobileNav ? 101 : layout.zIndexModal)};
  pointer-events: ${({ $open }) => ($open ? 'auto' : 'none')};
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: ${layout.desktopBreakpoint}) {
    align-items: flex-end;
    padding-bottom: ${({ $aboveMobileNav }) =>
      $aboveMobileNav
        ? `calc(${layout.mobileNavHeight} + env(safe-area-inset-bottom, 0px))`
        : 'env(safe-area-inset-bottom, 0px)'};
  }
`;

export const Overlay = styled.div<{ $open: boolean }>`
  position: fixed;
  inset: 0;
  background: ${semantic.bg.overlayModal};
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transition: opacity 250ms ease;
`;

export const Panel = styled.div<{ $open: boolean; $aboveMobileNav?: boolean; $size?: 'md' | 'lg' }>`
  position: relative;
  background: ${colors.white};
  border-radius: ${layout.borderRadiusLg};
  box-shadow: ${shadow.lg};
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  width: ${({ $size }) => ($size === 'lg' ? layout.modalWidthLg : layout.modalWidth)};
  max-width: calc(100vw - ${space[5]});
  opacity: ${({ $open }) => ($open ? 1 : 0)};
  transform: ${({ $open }) => ($open ? 'translateY(0)' : `translateY(${space[4]})`)};
  transition: opacity 250ms ease, transform 250ms ease;

  @media (max-width: ${layout.desktopBreakpoint}) {
    width: 100vw;
    max-width: 100vw;
    max-height: ${({ $aboveMobileNav, $size }) =>
      $aboveMobileNav
        ? `calc(100dvh - var(--shell-mobile-nav-height, 0px) - env(safe-area-inset-bottom, 0px))`
        : $size === 'lg'
        ? `calc(100dvh - ${space[7]} - env(safe-area-inset-bottom, 0px))`
        : 'calc(85dvh - env(safe-area-inset-bottom, 0px))'};
    border-radius: ${layout.borderRadiusXl} ${layout.borderRadiusXl} 0 0;
    transform: ${({ $open }) => ($open ? 'translateY(0)' : 'translateY(100%)')};
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${space[5]} ${space[5]} ${space[3]};
  flex-shrink: 0;
`;

export const Title = styled.h2`
  font-family: ${bodyFont};
  font-size: ${fonts.size.lg};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  margin: 0;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: ${space[1]};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${semantic.text.primary};
  font-size: ${fonts.size.xl};
  line-height: 1;
  border-radius: ${layout.borderRadius};
  transition: background 0.15s ease;

  &:hover {
    background: ${semantic.bg.surfaceSubtle};
  }
`;

export const Body = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 0 ${space[5]};
`;

export const Footer = styled.div`
  flex-shrink: 0;
  border-top: 1px solid ${semantic.border.subtle};
`;
